<template>
 <div class="tabthree">
    <div class="tabtitle">

    <router-link to="/List?menuid=9&text=手语专栏" tag="a" :class="['item',isActive==0?'cur':'']" @mouseenter.native="changeThree($event,0)"
              @mouseleave.native="changeThree($event,0)" >手语专栏</router-link>
    <router-link to="/List?menuid=7&text=服务指南" tag="a" :class="['item',isActive==1?'cur':'']" @mouseenter.native="changeThree($event,1)"
                @mouseleave.native="changeThree($event,1)" >服务指南</router-link>
    <router-link to="/List?menuid=8&text=组织机构" tag="a" :class="['item',isActive==2?'cur':'']" @mouseenter.native="changeThree($event,2)"
               @mouseleave.native="changeThree($event,2)" >组织机构</router-link>


              <!--
     <span :class="['item',isActive==0?'cur':'']" @mouseenter.stop="changeThree($event,0)"
               @mouseleave.stop="changeThree($event,0)" @click="changeThree($event,0)">服务指南</span>
      <span :class="['item',isActive==1?'cur':'']" @mouseenter.stop="changeThree($event,1)"
                @mouseleave.stop="changeThree($event,1)" @click="changeThree($event,1)">残疾人保障金</span>
      <span :class="['item',isActive==2?'cur':'']" @mouseenter.stop="changeThree($event,2)"
                @mouseleave.stop="changeThree($event,2)" @click="changeThree($event,2)">资料下载</span>

                -->
    </div>
    <div class="tablist">
      <div :class="['tab-box',isActive==0?'':'hide']">
          <ul class="news-list">
           <li v-for="item in newsList9" :key="item.id">
             <a v-if="item.id === '03cf3c674c244234ab0e0bbdc4a1eda4'" href="https://article.xuexi.cn/news/index.html?study_style_id=feeds_pure&showmenu=false&ref_read_id=98beb0d7-3ba0-4c4a-8e53-59283ef6eb02_1709540951778&pid=&ptype=-1&source=share&share_to=wx_single#/special-topic/12321871481945568" target="_blank" >{{item.title}}</a><!-- 国家通用手语词典 -->
             <a v-else-if="item.id === '1455caa9a4f6450a9dc1f4463741309f'" href="https://article.xuexi.cn/news/index.html?study_style_id=feeds_pure&showmenu=false&ref_read_id=ad140e97-00b6-446f-9ed6-22643748c831_1709540658931&pid=&ptype=-1&source=share&share_to=wx_single#/special-topic/69965272732713236" target="_blank">{{item.title}}</a> <!-- 一起学手语 -->
             <a v-else href="javascript:;" @click="goArticle(item.id)">{{item.title}}</a>
           </li>

          </ul>
      </div>
      <div :class="['tab-box',isActive==1?'':'hide']">
          <ul class="news-list">
           <li v-for="item in newsList7" :key="item.id">
                        <a href="javascript:;" @click="goArticle(item.id)">{{item.title}}</a>
                      </li>

          </ul>
      </div>
      <div :class="['tab-box',isActive==2?'':'hide']">
          <ul class="news-list">
           <li v-for="item in newsList8" :key="item.id">
                        <a href="javascript:;" @click="goArticle(item.id)">{{item.title}}</a>
                      </li>

          </ul>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'tabthree',
  components: {},
  data () {
     return {
      isActive:0,
       newsList7:[],
            newsList8:[],
            newsList9:[]
   }
  },
  mounted() {
    this.findPageList(7)
    this.findPageList(8)
    this.findPageList(9)
  },
  methods: {
    goArticle(articleId){
        let {href}= this.$router.resolve({
           path: "/Article",   // 这里写的是要跳转的路由地址
           query: {articleId:articleId}  // 这里写的是页面参数
        });
        window.open(href, '_blank');
    },
    changeThree(e,num){
      console.log(num)
      this.isActive = num;
    },
    findPageList(type){
          var that=this;
          that.$myHttp.post("findPageList?type="+type+"&pageSize=6")
                  		  .then(function(data) {
                          console.log(data)
                  		    if (data.status == "200") {
                              if (type == 7)
                                that.newsList7 = data.data.page.list;
                              if (type == 8)
                                that.newsList8 = data.data.page.list;
                              if (type == 9)
                                that.newsList9 = data.data.page.list;

                  		    }  else {
                  		      alert("数据请求错误")
                  		    }

                  		  }).catch(function(error) {
                  		    alert(error)
                  		  })
        }
  }
};
</script>

<style scoped>
.tabthree{
  width:300px;
}
.tabtitle{
  height:36px;
  line-height:36px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #199352;
}
.tabtitle .item{
  width:33.333%;
  text-align: center;
  font-weight: bold;
  color:#444;
}
.tabtitle .item:hover{
  cursor: pointer;
}
.tabtitle .cur{
  font-size:14px;
  color:#fff;
  background: #199352;
  font-weight: bold;
}
.title .box-name{
  font-size:14px;
  color:#fff;
  background: #199352;
  font-weight: bold;
  padding:0 10px;
}
.title .more{
  color:#515151;
  font-size:12px;
  padding-right:15px;
  background: url(../../../assets/img/1.png) no-repeat right center;
}
.news-list{
  padding-top:10px;
}
.news-list li a{
  font-size:15px;
  line-height:31px;
  display: block;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
   color:#333;
   padding-left: 10px;
  background: url(/static/img/dot.jpg) left center no-repeat;
}
.news-list li a:hover{
  color: red;
  text-decoration: underline;
}
.hide{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/front/components/tabthree.vue